import Signup, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/signup';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Signup;
